"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "prato-carnico": {
    "87abb91a": [{
      "hkey": "fbba3eb1",
      "slug": "osais-pesariis",
      "name": "Osais-Pesariis",
      "primary": true,
      "skipSearch": false
    }],
    "osais": [{
      "hkey": "fbba3eb1",
      "slug": "osais-pesariis",
      "name": "Osais-Pesariis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "172ecfb1": [{
      "hkey": "fbba3eb1",
      "slug": "osais-pesariis",
      "name": "Osais-Pesariis",
      "primary": true,
      "skipSearch": false
    }],
    "pesariis": [{
      "hkey": "fbba3eb1",
      "slug": "osais-pesariis",
      "name": "Osais-Pesariis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prato-carnico"
    }],
    "0df722ea": [{
      "hkey": "5896a47a",
      "slug": "sostasio-croce",
      "name": "Sostasio-Croce",
      "primary": true,
      "skipSearch": false
    }],
    "sostasio": [{
      "hkey": "5896a47a",
      "slug": "sostasio-croce",
      "name": "Sostasio-Croce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aa11f033": [{
      "hkey": "acb42ad7",
      "slug": "truia",
      "name": "Truia",
      "primary": true,
      "skipSearch": false
    }],
    "truja": [{
      "hkey": "acb42ad7",
      "slug": "truia",
      "name": "Truia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;